// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__dc-1y","checkmark":"Checkbox_checkmark__1UxaQ","checkmarkSquare":"Checkbox_checkmarkSquare__1P4sj"};